export const FETCH_ERRORS = 'error/GET_ERRORS';
export const CLEAR_ERRORS = 'error/CLEAR_ERRORS';